import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import { task, type TaskForAsyncTaskFunction } from 'ember-concurrency';
import type { CostSettingProfile } from 'lumen/models';
import { FEATURE_TOGGLES } from 'lumen/utils/constants/feature-toggle-constants';
import protectedRoute from 'lumen/utils/decorators/protected-route';
import SilentTaskError, {
  getErrorMessage,
} from 'lumen/utils/silent-task-error';

export type CostModel = {
  profiles: TaskForAsyncTaskFunction<
    { restartable: boolean },
    () => Promise<CostSettingProfile[]>
  >;
};

// @ts-expect-error: Unable to resolve signature of class decorator when called as an expression.
@protectedRoute({
  features: ['settings.cost_profiles.view'],
  featureToggles: FEATURE_TOGGLES.NET_REVENUE_SETTINGS,
  redirectTo: 'market.settings',
})
export default class MarketSettingsCostRoute extends Route {
  @service declare alerting: Services['alerting'];
  @service declare errorTracking: Services['error-tracking'];
  @service declare store: Services['store'];

  getProfilesTask = task(
    { restartable: true },
    async (): Promise<CostSettingProfile[]> => {
      try {
        return await this.store.query<CostSettingProfile>(
          'cost-setting/profile',
          {},
        );
      } catch (error) {
        this.errorTracking.captureException(error);

        throw new SilentTaskError(getErrorMessage(error));
      }
    },
  );

  async loadProfiles(): Promise<void> {
    try {
      await this.getProfilesTask.perform();
    } catch {
      void this.alerting.showErrorAlert();
    }
  }

  model(): CostModel {
    const model: CostModel = {
      profiles: this.getProfilesTask,
    };

    void this.loadProfiles();

    return model;
  }
}
